import { store } from 'store/index'
import { ActivityItemVm } from './activity-item-vm'
import { FeedbackRequestedActivity } from 'store/modules/activities'

export class FeedbackRequestActivityItemVm extends ActivityItemVm<FeedbackRequestedActivity> {
  get content() {
    return this.activity.record.content
  }

  get receivers() {
    return this.activity.record.users
  }

  get creator() {
    return this.activity.creator
  }

  get title() {
    return 'Requested Feedback'
  }

  get feedbackRequest() {
    return this.activity.record
  }

  get responsesCount() {
    return this.feedbackRequest.responsesCount
  }

  feedbackItemAuthoredBy(userId: string) {
    return store.feedbackItems.filtered((item) => {
      return (
        item.feedbackRequest === this.feedbackRequest &&
        item.author.id === userId
      )
    })[0]
  }

  get awaitingResponseCount() {
    return this.feedbackRequest.awaitingResponseCount
  }

  get userIsReceiver() {
    return this.receivers.some((user) => user.id === store.currentUser?.id)
  }
}
